/* unplugin-vue-components disabled */import script from "./DownloadComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadComponents.vue?vue&type=script&setup=true&lang=js"

import "./DownloadComponents.vue?vue&type=style&index=0&id=2a4ffa93&lang=less"

const __exports__ = script;

export default __exports__